const { animate, inView, stagger, anime, scrollDirection } = window;

function klx_logos_animation(logos, opacity=1, translateY=0) {
    var _logos = logos;
    if (window.scrollDirection === 'up') {
        _logos = Array.from(_logos).reverse();
        console.log(window.scrollDirection);
    }
    anime({
        targets: _logos,
        opacity: opacity,
        translateY: translateY,
        duration: 500,
        delay: anime.stagger(40),
        easing: 'easeInElastic(1, .6)'
    });
}

document.querySelectorAll('.wp-block-klx-logos').forEach(logos => {
    inView(logos, (_) => {
        var translate = [[10, 0], [0, 10]];
        if (window.scrollDirection === 'up') {
            translate = [[-10, 0], [0, -10]];
        }
        klx_logos_animation(logos.querySelectorAll('figure,p'), [.4, 1], translate[0]);
        return (_) => {
            klx_logos_animation(logos.querySelectorAll('figure,p'), [1, .4], translate[1]);
        }
    });
});
